import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidKlankSwitch } from '../../../../mechanics/rid-klank-switch/rid-klank-switch';
import { injectQueryParams } from '../../../../utils/route.utils';

@Component({
  selector: 'app-klank-switch-page',
  imports: [RidKlankSwitch],
  templateUrl: './klank-switch-page.html',
})
export class KlankSwitchPage {
  protected readonly router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly shuffle = computed(() => parseInt(this.queryParams()['shuffle'] ?? '1'));
}
